var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStripeLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14013_172776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H32C34.2091 0 36 1.79086 36 4V32C36 34.2091 34.2091 36 32 36H4C1.79086 36 0 34.2091 0 32V4Z",
    fill: "url(#paint0_linear_14013_172776)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_14013_172776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6436 15.6093C17.8258 14.9371 16.8296 14.414 16.8296 13.5923C16.8296 12.8948 17.4023 12.4965 18.4234 12.4965C20.2911 12.4965 22.2085 13.2188 23.5284 13.8661L24.2754 9.25922C23.2294 8.76113 21.0878 7.93945 18.1245 7.93945C16.0328 7.93945 14.2896 8.48719 13.0445 9.50827C11.7494 10.579 11.0772 12.123 11.0772 13.9907C11.0772 17.3774 13.1441 18.8217 16.5059 20.0419C18.6723 20.814 19.3946 21.3618 19.3946 22.2084C19.3946 23.0302 18.6971 23.5033 17.4272 23.5033C15.8583 23.5033 13.2687 22.7314 11.5751 21.7353L10.8281 26.392C12.2723 27.2138 14.9618 28.0604 17.7511 28.0604C19.9673 28.0604 21.8101 27.5375 23.0552 26.5415C24.4496 25.4457 25.1719 23.8271 25.1719 21.7353C25.1719 18.2738 23.0552 16.8295 19.6435 15.6094L19.6436 15.6093Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14013_172776",
    x: 10.125,
    y: 7.23633,
    width: 16.3125,
    height: 22.0898,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.28125,
    dy: 0.28125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.492188
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.185125 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14013_172776"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14013_172776",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14013_172776",
    x1: 3600,
    y1: 2100.82,
    x2: 0,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2697D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#207BCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2285CE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14013_172776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeLogo);
export default __webpack_public_path__ + "static/media/stripe-logo.dca58d773374f617b8f466b6605e6da7.svg";
export { ForwardRef as ReactComponent };